import { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import '../clientes.css';
import axios from 'axios';

export default function Clientes() {
  const [clientes, setClientes] = useState([]);
  const [mostrarModal, setMostrarModal] = useState(false);
  const [modoEdicion, setModoEdicion] = useState(false);
  const [clienteEditandoId, setClienteEditandoId] = useState(null);

  const [clienteFormulario, setClienteFormulario] = useState({
    nombre: '',
    correo: '',
    telefono: ''
  });

  const year = new Date().getFullYear();
  const location = useLocation();

  useEffect(() => {
    cargarClientes();
  }, []);

  const cargarClientes = () => {
    axios
      .get('https://api-rci-g5ebbhava3anbgfy.centralus-01.azurewebsites.net/api/clientes')
      .then(res => setClientes(res.data))
      .catch(err => console.error('Error al cargar clientes:', err));
  };

  const verProyectos = async (clienteID, nombreCliente) => {
    try {
      const res = await axios.get(`https://api-rci-g5ebbhava3anbgfy.centralus-01.azurewebsites.net/api/Proyectos?clienteId=${clienteID}`);
      const proyectos = res.data || [];

      if (proyectos.length === 0) {
        alert(`${nombreCliente} no tiene proyectos registrados.`);
        return;
      }

      const lista = proyectos
        .map(p => `• ${p.nombre ?? p.Nombre}`)
        .join('\n');

      alert(`Proyectos de ${nombreCliente}:\n\n${lista}`);
    } catch (err) {
      console.error('Error al cargar proyectos del cliente:', err);
      alert('No se pudieron cargar los proyectos del cliente.');
    }
  };

  const abrirModalNuevo = () => {
    setModoEdicion(false);
    setClienteEditandoId(null);
    setClienteFormulario({
      nombre: '',
      correo: '',
      telefono: ''
    });
    setMostrarModal(true);
  };

  const abrirModalEditar = (cliente) => {
    setModoEdicion(true);
    setClienteEditandoId(cliente.clienteID);
    setClienteFormulario({
      nombre: cliente.nombre || '',
      correo: cliente.correo || '',
      telefono: cliente.telefono || ''
    });
    setMostrarModal(true);
  };

  const cerrarModal = () => {
    setMostrarModal(false);
    setModoEdicion(false);
    setClienteEditandoId(null);
    setClienteFormulario({
      nombre: '',
      correo: '',
      telefono: ''
    });
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setClienteFormulario(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const guardarCliente = async () => {
    const { nombre, correo, telefono } = clienteFormulario;

    if (!nombre || !correo || !telefono) {
      alert('Todos los campos son obligatorios');
      return;
    }

    try {
      if (modoEdicion) {
        await axios.put(
          `https://api-rci-g5ebbhava3anbgfy.centralus-01.azurewebsites.net/api/clientes/${clienteEditandoId}`,
          clienteFormulario
        );

        alert('Cliente actualizado correctamente');
      } else {
        await axios.post(
          'https://api-rci-g5ebbhava3anbgfy.centralus-01.azurewebsites.net/api/clientes',
          clienteFormulario
        );

        alert('Cliente guardado correctamente');
      }

      cerrarModal();
      cargarClientes();
    } catch (err) {
      console.error('Error al guardar cliente:', err);
      alert(modoEdicion ? 'Error al actualizar cliente' : 'Error al guardar cliente');
    }
  };

  const eliminarCliente = async (clienteID) => {
    const confirmar = window.confirm('¿Seguro que deseas eliminar este cliente?');

    if (!confirmar) return;

    try {
      await axios.delete(`https://api-rci-g5ebbhava3anbgfy.centralus-01.azurewebsites.net/api/clientes/${clienteID}`);
      alert('Cliente eliminado correctamente');
      cargarClientes();
    } catch (err) {
      console.error('Error al eliminar cliente:', err);

      if (err.response?.status === 409) {
        alert('No se puede eliminar este cliente porque tiene cotizaciones o proyectos relacionados.');
      } else {
        alert('Error al eliminar cliente');
      }
    }
  };

  return (
    <div className="dashboard-layout">
      <aside className="sidebar">
        <div className="sidebar-title">RCI</div>

        <nav>
          <Link
            to="/dashboard"
            className={location.pathname === '/dashboard' ? 'active' : ''}
          >
            Inicio
          </Link>

          <Link
            to="/cotizaciones"
            className={location.pathname.startsWith('/cotizaciones') ? 'active' : ''}
          >
            Cotizaciones
          </Link>

          <Link
            to="/generadores"
            className={location.pathname.startsWith('/generadores') ? 'active' : ''}
          >
            Generadores
          </Link>

          <Link
            to="/proyectos"
            className={location.pathname.startsWith('/proyectos') ? 'active' : ''}
          >
            Proyectos
          </Link>

          <Link
            to="/clientes"
            className={location.pathname.startsWith('/clientes') ? 'active' : ''}
          >
            Clientes
          </Link>
        </nav>
      </aside>

      <div className="main-area">
        <header className="header">Administrador de Proyectos</header>

        <main className="content">
          <div className="clientes-header">
            <h2>Clientes</h2>

            <button className="btn-nuevo" onClick={abrirModalNuevo}>
              + Nuevo Cliente
            </button>
          </div>
          
          <div className="table-container">
            <table className="tabla-clientes">
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Nombre</th>
                  <th>Email</th>
                  <th>RFC</th>
                  <th>Acciones</th>
                </tr>
              </thead>

              <tbody>
                {clientes.map(cliente => (
                  <tr key={cliente.clienteID}>
                    <td>{cliente.clienteID}</td>
                    <td>{cliente.nombre}</td>
                    <td>{cliente.correo}</td>
                    <td>{cliente.telefono}</td>

                    <td className="acciones-clientes">
                      <button
                        className="btn-accion btn-ver"
                        onClick={() => verProyectos(cliente.clienteID, cliente.nombre)}
                      >
                        Ver Proyectos
                      </button>

                      <button
                        className="btn-accion btn-editar"
                        onClick={() => abrirModalEditar(cliente)}
                      >
                        Editar
                      </button>

                      <button
                        className="btn-accion btn-eliminar"
                        onClick={() => eliminarCliente(cliente.clienteID)}
                      >
                        Eliminar
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {mostrarModal && (
            <div className="modal-overlay">
              <div className="modal-box">
                <h3>{modoEdicion ? 'Editar Cliente' : 'Nuevo Cliente'}</h3>

                <input
                  type="text"
                  name="nombre"
                  placeholder="Nombre"
                  value={clienteFormulario.nombre}
                  onChange={handleInputChange}
                />

                <input
                  type="email"
                  name="correo"
                  placeholder="Correo"
                  value={clienteFormulario.correo}
                  onChange={handleInputChange}
                />

                <input
                  type="text"
                  name="telefono"
                  placeholder="RFC"
                  value={clienteFormulario.telefono}
                  onChange={handleInputChange}
                />

                <div className="modal-actions">
                  <button className="btn" onClick={guardarCliente}>
                    {modoEdicion ? 'Actualizar' : 'Guardar'}
                  </button>

                  <button className="btn-cancelar" onClick={cerrarModal}>
                    Cancelar
                  </button>
                </div>
              </div>
            </div>
          )}
        </main>

        <footer className="footer">© {year} RCI</footer>
      </div>
    </div>
  );
}